import { useQuery } from "@tanstack/react-query";

import DataSvc from "../../../services/dataSvc";

const useKeywordAnalysisDetail = (
  locationId: string,
  keywordAnalysisId: string,
  organizationId?: string | number
) => {
  return useQuery(
    ["keywordAnalysisDetail", locationId, keywordAnalysisId, organizationId],
    async () => {
      return await DataSvc.getKeywordAnalysisDetail(
        locationId,
        keywordAnalysisId,
        organizationId
      );
    },
    {
      enabled: !!locationId && !!keywordAnalysisId,
    }
  );
};

export default useKeywordAnalysisDetail;
